import React, { useEffect, useState, useMemo } from "react";
import ReactSelect from "react-select";
import { useStateContext } from "../../../../../../Context/StateContext";

export default function CategoryFilterForPosts({ values, filter, industries }) {
  const { state, setKeywords, setSubcategories } = useStateContext();
  const { keywords } = state;

  // Local states
  const [allSkills, setAllSkills] = useState([]);
  const [selectSkills, setSelectSkills] = useState(null);

  // On values change, save all
  useEffect(() => {
    if (Array.isArray(values)) {
      setAllSkills(values);
    }
  }, [values]);

  // Collect industry ids
  const industryIds = useMemo(
    () => (Array.isArray(industries) ? industries.map((i) => i.id) : []),
    [industries]
  );

  // Filter allSkills based on selected industries
  const filteredSkills = useMemo(() => {
    if (!Array.isArray(allSkills)) return [];
    if (industryIds.length === 0) return [];
    return allSkills.filter((item) => industryIds.includes(item.parent_id));
  }, [allSkills, industryIds]);

  // Add selected item to global state
  const handleLanguageChange = (selectedOption) => {
    const newLanguage = {
      id: selectedOption.value,
      title: selectedOption.label,
    };
    setKeywords([...(keywords || []), newLanguage]);
    setSelectSkills(null); // clear after adding
  };

  // Remove selected item
  const handleDeleteLanguage = (id) => {
    const updatedLanguages = (keywords || []).filter((language) => language.id !== id);
    setKeywords(updatedLanguages);
    setSubcategories([])
  };

  return (
    <div>
      <ReactSelect
        options={filteredSkills
          .filter((lang) => !(keywords || []).some((sel) => sel.id === lang.id))
          .map((lang) => ({ value: lang.id, label: lang.title }))}
        placeholder={`Select ${filter?.title || ""}`}
        isClearable
        value={selectSkills}
        onChange={(option) => {
          if (option) handleLanguageChange(option);
        }}
      />

      <div className="add-skills">
        {(keywords || []).map((skill) => (
          <div key={skill.id}>
            <p onClick={() => handleDeleteLanguage(skill.id)}>
              {skill.title} <span>x</span>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
